import React, { useEffect, useState } from 'react';
import { XIcon, ZapIcon } from 'lucide-react';
import { purchaseAlerts } from '../data/purchaseAlerts';
import { CHECKOUT_URL, PRODUCT_NAME } from './constants';
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timeoutId: number;
    const showTimer = window.setTimeout(() => setVisible(true), 4000);
    const cycle = window.setInterval(() => {
      setVisible(false);
      timeoutId = window.setTimeout(() => {
        setIndex(prev => (prev + 1) % purchaseAlerts.length);
        setVisible(true);
      }, 500);
    }, 9000);
    return () => {
      window.clearTimeout(showTimer);
      window.clearInterval(cycle);
      window.clearTimeout(timeoutId);
    };
  }, [dismissed]);
  if (dismissed) return null;
  const alert = purchaseAlerts[index];
  return <div aria-live="polite" className={`fixed bottom-3 left-3 z-50 max-w-[280px] transition-[opacity,transform] duration-200 ease-out sm:max-w-[320px] ${visible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-3 opacity-0'}`} data-id="element-145" data-mp="1gwui4isaqulw">
      <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="flex items-start gap-2 rounded-lg border-2 border-ev-green bg-ev-black px-3 py-2 shadow-[0_10px_26px_-10px_rgba(116,240,68,0.7)]" data-id="element-146" data-mp="1fv93jg5suk6r">
        <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-ev-green" data-id="element-147" data-mp="i8jwut05jjek">
          <ZapIcon aria-hidden="true" className="h-4 w-4 text-ev-black" data-id="element-148" data-mp="x5kqx35tfqg7" />
        </span>
        <span className="min-w-0" data-id="element-149" data-mp="s5onb5116116">
          <span className="block font-sans text-[12px] font-extrabold leading-tight text-white" data-id="element-150" data-mp="s5erh0tb0znk">
            {alert.name} — {alert.city}, {alert.country}
          </span>
          <span className="block text-[11px] font-semibold leading-tight text-ev-neon" data-id="element-151" data-mp="23m67o6rcsd7g">
            Just purchased {PRODUCT_NAME}
          </span>
          <span className="block text-[10px] font-semibold uppercase tracking-wide text-ev-steel" data-id="element-152" data-mp="2aobbih2afotc">
            {alert.minutesAgo} minutes ago
          </span>
        </span>
        <button type="button" aria-label="Close notification" onClick={event => {
        event.preventDefault();
        setDismissed(true);
      }} className="ml-auto -mr-1 -mt-1 shrink-0 p-1 text-ev-steel transition-colors duration-150 ease-out hover:text-white" data-id="element-153" data-mp="2ko2b2x5pgu0a">
          <XIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-154" data-mp="1wv29x2kl07ld" />
        </button>
      </a>
    </div>;
}